import { Sizes } from '@ratehub/base-ui';


export default {
    NONE: '0',
    SMALL: Sizes.SPACING.FOUR,
    MEDIUM: Sizes.SPACING.SIX,
    LARGE: Sizes.SPACING.EIGHT,
};
